import "core-js/modules/web.dom-collections.iterator.js";
import React, { useEffect, useMemo } from 'react';
import { Form } from 'react-final-form';
import { StandardButton } from '@eika/button';
import { InstitutionType, YesNoAnswer } from '../../generated-types';
import StandaloneYesNoQuestionType from '../../types/standalone-yes-no-question-type';
import { StandardInputField } from '../../types/standard-input-field';
import FinancialInstitutionHelpModal from '../../util/helpModals/corporate/financial-institution-help-modal';
import PassiveFinancialInstitutionHelpModal from '../../util/helpModals/corporate/passive-financial-institution-help-modal';
import { composeValidators, focusOnErrors, globalIntermediaryIdentificationNumber, requiredField, validateCountry, validType } from '../../util/validator';
import OverlayLoader from '../overlay-loader';
const FinancialInstitution = _ref => {
  var _section$globalInterm2;
  let {
    section,
    goToNext,
    error,
    submitted,
    submitting,
    doSubmitCorporateInstitutionTypeSection,
    getCountries,
    countries
  } = _ref;
  const labels = {
    header: 'Finansiell institusjon',
    isFinancialInstitution: 'Er virksomheten en finansiell institusjon som tilbyr tjenester innen bank, finans, forsikring, verdipapir, fond eller tilsvarende?',
    globalIntermediaryIdentificationNumber: 'GIIN',
    isPassiveCorporate: 'Er mer enn 50% av inntektene/aktiva i virksomheten passive inntekter?'
  };
  const getInitialValues = () => {
    const values = {};
    if (section.financialInstitution != null || section.passiveCorporate != null) {
      if (section.financialInstitution) {
        var _section$globalInterm;
        values.isFinancialInstitution = YesNoAnswer.YES;
        if ((_section$globalInterm = section.globalIntermediaryIdentificationNumber) !== null && _section$globalInterm !== void 0 && _section$globalInterm.number) {
          values.globalIntermediaryIdentificationNumber = section.globalIntermediaryIdentificationNumber.number;
        }
      } else {
        values.isFinancialInstitution = YesNoAnswer.NO;
      }
      if (section.passiveCorporate) {
        values.isPassiveCorporate = YesNoAnswer.YES;
      } else {
        values.isPassiveCorporate = YesNoAnswer.NO;
      }
    }
    return values;
  };
  const initialValues = useMemo(getInitialValues, [section.financialInstitution, (_section$globalInterm2 = section.globalIntermediaryIdentificationNumber) === null || _section$globalInterm2 === void 0 ? void 0 : _section$globalInterm2.number, section.passiveCorporate]);
  useEffect(() => {
    if (submitted && !error) {
      goToNext();
    }
  }, [error, submitted, goToNext]);
  useEffect(() => {
    if (countries.countries.length < 1) {
      getCountries();
    }
  }, [countries.countries, getCountries]);
  const submitAnswers = values => {
    let corporateInstitutionType = {};
    if (values.isFinancialInstitution === YesNoAnswer.YES) {
      corporateInstitutionType = {
        globalIntermediaryIdentificationNumber: {
          number: values.globalIntermediaryIdentificationNumber
        },
        typeInfo: InstitutionType.financialInstitution
      };
    } else if (values.isFinancialInstitution === YesNoAnswer.NO) {
      corporateInstitutionType = {
        passiveCorporate: values.isPassiveCorporate === YesNoAnswer.YES,
        typeInfo: InstitutionType.nonFinancialInstitution
      };
    }
    doSubmitCorporateInstitutionTypeSection(corporateInstitutionType);
  };
  const validateGlobalIntermediaryIdentificationNumberCountry = value => {
    return validateCountry(value, countries);
  };
  const getFinancialInstitutionQuestionLabel = () => {
    return /*#__PURE__*/React.createElement("div", null, labels.isFinancialInstitution, /*#__PURE__*/React.createElement(FinancialInstitutionHelpModal, null));
  };
  const getPassiveFinancialInstitutionQuestionLabel = () => {
    return /*#__PURE__*/React.createElement("div", null, labels.isPassiveCorporate, /*#__PURE__*/React.createElement(PassiveFinancialInstitutionHelpModal, null));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, submitting && /*#__PURE__*/React.createElement(OverlayLoader, null), /*#__PURE__*/React.createElement("h2", {
    className: "header-title"
  }, labels.header), /*#__PURE__*/React.createElement(Form, {
    onSubmit: submitAnswers,
    decorators: [focusOnErrors],
    formName: "financial-institution-form",
    initialValues: initialValues
  }, props => {
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: props.handleSubmit
    }, /*#__PURE__*/React.createElement(StandaloneYesNoQuestionType, {
      label: labels.isFinancialInstitution,
      name: "isFinancialInstitution",
      selected: props.values.isFinancialInstitution,
      validate: requiredField,
      overrideLabel: getFinancialInstitutionQuestionLabel()
    }), props.values.isFinancialInstitution === YesNoAnswer.YES && /*#__PURE__*/React.createElement(StandardInputField, {
      label: labels.globalIntermediaryIdentificationNumber,
      name: "globalIntermediaryIdentificationNumber",
      validate: composeValidators(requiredField, globalIntermediaryIdentificationNumber, validType, validateGlobalIntermediaryIdentificationNumberCountry),
      className: "form-question"
    }), props.values.isFinancialInstitution === YesNoAnswer.NO && /*#__PURE__*/React.createElement(StandaloneYesNoQuestionType, {
      selected: props.values.isPassiveCorporate,
      label: labels.isPassiveCorporate,
      name: "isPassiveCorporate",
      validate: requiredField,
      extraClass: "form-question",
      overrideLabel: getPassiveFinancialInstitutionQuestionLabel()
    }), /*#__PURE__*/React.createElement(StandardButton, {
      className: "progress-next-button",
      type: "submit"
    }, "Neste"));
  }));
};
export default FinancialInstitution;